import { Center, Loader } from "@mantine/core"

export function PageFallback() {
  return (
    <Center style={{ height: "100vh" }}>
      <Loader color="violet" variant="bars" />
    </Center>
  )
}
